// T21 – "Buy Now" in Horizon's sticky add-to-cart bar: adds the current variant and goes to checkout.
// Delegated, so it keeps working after the bar is re-rendered on variant change.
const root = window.Shopify?.routes?.root || '/';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-t21-buy-now]') : null;
  if (!button) return;

  const sticky = button.closest('sticky-add-to-cart');
  const variantId = Number(sticky?.dataset.currentVariantId);
  if (!variantId) return;

  const quantityInput = document.querySelector('.product-information input[name="quantity"]');
  const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);

  button.setAttribute('aria-busy', 'true');
  button.disabled = true;

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    if (!response.ok) throw new Error(`cart/add ${response.status}`);
    window.location.href = `${root}checkout`;
  } catch (error) {
    console.warn('[t21-sticky-atc] Buy now failed:', error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
